export default __webpack_public_path__ + "static/media/profileimg.8498400b.png";